import React from 'react'
import ContactUs from './Contactus/Contactus'

const Contact = () => {
  return (
    <>
        <ContactUs/>
    </>
  )
}

export default Contact